import { ref } from 'vue'

const isDark = ref(false)

export function useTheme() {
  const setTheme = (dark) => {
    isDark.value = dark
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light')
    localStorage.setItem('omega-theme', dark ? 'dark' : 'light')
  }

  const toggleTheme = () => setTheme(!isDark.value)

  const initTheme = () => {
    const saved = localStorage.getItem('omega-theme')
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    setTheme(saved ? saved === 'dark' : prefersDark)
  }

  return { isDark, toggleTheme, initTheme }
}
